/** @format */

// component
import Iconify from '../components/Iconify';
import { blacklistUser } from 'src/static/blacklist';

// ----------------------------------------------------------------------

const getIcon = (name) => <Iconify icon={name} width={22} height={22} />;

let userSidebarConfig = [
  {
    title: "dashboard",
    path: "/dashboard",
    icon: getIcon("eva:pie-chart-2-fill"),
  },
  // {
  //   title: 'WhatsApp Numbers',
  //   path: '/number',
  //   icon: getIcon('eva:phone-fill'),
  // },
  {
    title: "message templates",
    path: "/template",
    icon: getIcon("eva:file-text-fill"),
  },
  {
    title: "Broadcast",
    path: "/broadcast",
    icon: getIcon("material-symbols:campaign"),
  },
  {
    title: "Main Credits",
    path: "/credits",
    disabled: true,
    icon: getIcon("ph:credit-card-fill"),
  },
];

let userSidebarConfigPending = [
  {
    title: "dashboard",
    path: "/dashboard",
    icon: getIcon("eva:pie-chart-2-fill"),
  },
  // {
  //   title: 'WhatsApp Numbers',
  //   path: '/number',
  //   disabled: true,
  //   icon: getIcon('eva:phone-fill'),
  // },
  {
    title: "message templates",
    path: "/template",
    disabled: true,
    icon: getIcon("eva:file-text-fill"),
  },
  {
    title: "Broadcast",
    path: "/broadcast",
    icon: getIcon("material-symbols:campaign"),
  },
  {
    title: "Main Credits",
    path: "/credits",
    disabled: true,
    icon: getIcon("ph:credit-card-fill"),
  },
];

let userSidebarConfigBlackList = [
  {
    title: "dashboard",
    path: "/dashboard",
    icon: getIcon("eva:pie-chart-2-fill"),
  },
  // {
  //   title: 'WhatsApp Numbers',
  //   path: '/number',
  //   icon: getIcon('eva:phone-fill'),
  // },
  {
    title: "Marketing",
    path: "/marketing",
    icon: getIcon("icon-park-outline:weixin-market"),
    // disabled: true,
  },
  // {
  //   title: "message templates",
  //   path: "/template",
  //   icon: getIcon("eva:file-text-fill"),
  // },
  // {
  // {
  //   title: "Broadcast",
  //   path: "/broadcast",
  //   icon: getIcon("material-symbols:campaign"),
  // },
  {
    title: "Main Credits",
    path: "/credits",
    disabled: true,
    icon: getIcon("ph:credit-card-fill"),
  },
];

let adminSidebarConfig = [
  {
    title: 'dashboard',
    path: '/dashboard',
    icon: getIcon('eva:pie-chart-2-fill'),
  },
  {
    title: 'users',
    path: '/user',
    icon: getIcon('eva:people-fill'),
  },
  {
    title: 'Master Waba',
    path: '/waba-master',
    icon: getIcon('akar-icons:whatsapp-fill'),
  },
  {
    title: 'WhatsApp Numbers',
    path: '/number',
    icon: getIcon('eva:phone-fill'),
  },
  // {
  //   title: "Approval Master",
  //   path: "/approveMaster",
  //   icon: getIcon("wpf:approval"),
  //   // disabled: true,
  // },
  {
    title: 'Cost Master',
    path: '/costMaster',
    icon: getIcon('solar:money-bag-linear'),
    // disabled: true,
  },
  {
    title: 'OTP Manager',
    path: '/otpManager',
    icon: getIcon('solar:money-bag-linear'),
    // disabled: true,
  },
  {
    title: 'message templates',
    path: '/template',
    icon: getIcon('eva:file-text-fill'),
  },
  {
    title: 'Broadcast',
    path: '/broadcast',
    icon: getIcon('material-symbols:campaign'),
  },
  // {
  //   title: "Marketing",
  //   path: "/marketing",
  //   icon: getIcon("icon-park-outline:weixin-market"),
  //   // disabled: true,
  // },
  {
    title: 'Main Credits',
    path: '/credits',
    disabled: false,
    icon: getIcon('ph:credit-card-fill'),
  },
];

let adminSidebarConfigDisabled = [
  {
    title: 'dashboard',
    path: '/dashboard',
    icon: getIcon('eva:pie-chart-2-fill'),
  },
  {
    title: 'users',
    path: '/user',
    icon: getIcon('eva:people-fill'),
  },
  {
    title: 'Master Waba',
    path: '/waba-master',
    icon: getIcon('akar-icons:whatsapp-fill'),
  },
  {
    title: 'WhatsApp Numbers',
    path: '/number',
    icon: getIcon('eva:phone-fill'),
  },
  // {
  //   title: "Approval Master",
  //   path: "/approveMaster",
  //   icon: getIcon("wpf:approval"),
  //   // disabled: true,
  // },
  {
    title: 'Cost Master',
    path: '/costMaster',
    icon: getIcon('solar:money-bag-linear'),
    disabled: true,
  },
  {
    title: 'OTP Manager',
    path: '/otpManager',
    icon: getIcon('solar:money-bag-linear'),
    disabled: true,
  },
  {
    title: 'message templates',
    path: '/template',
    icon: getIcon('eva:file-text-fill'),
  },
  {
    title: 'Broadcast',
    path: '/broadcast',
    icon: getIcon('material-symbols:campaign'),
  },
  // {
  //   title: "Marketing",
  //   path: "/marketing",
  //   icon: getIcon("icon-park-outline:weixin-market"),
  //   // disabled: true,
  // },
  {
    title: 'Main Credits',
    path: '/credits',
    disabled: true,
    icon: getIcon('ph:credit-card-fill'),
  },
];

let adminSidebarConfigPending = [
  {
    title: 'dashboard',
    path: '/dashboard',
    icon: getIcon('eva:pie-chart-2-fill'),
  },
  {
    title: 'users',
    path: '/user',
    icon: getIcon('eva:people-fill'),
    disabled: true,
  },
  {
    title: 'Master Waba',
    path: '/waba-master',
    icon: getIcon('akar-icons:whatsapp-fill'),
    disabled: true,
  },
  {
    title: 'WhatsApp Numbers',
    path: '/number',
    icon: getIcon('eva:phone-fill'),
    disabled: true,
  },
  {
    title: 'message templates',
    path: '/template',
    icon: getIcon('eva:file-text-fill'),
    disabled: true,
  },
  {
    title: 'Broadcast',
    path: '/broadcast',
    icon: getIcon('material-symbols:campaign'),
  },
  {
    title: 'Main Credits',
    path: '/credits',
    disabled: true,
    icon: getIcon('ph:credit-card-fill'),
  },
];

let adminSidebarConfigBlackList = [
  {
    title: 'dashboard',
    path: '/dashboard',
    icon: getIcon('eva:pie-chart-2-fill'),
  },
  {
    title: 'users',
    path: '/user',
    icon: getIcon('eva:people-fill'),
  },
  {
    title: 'Master Waba',
    path: '/waba-master',
    icon: getIcon('akar-icons:whatsapp-fill'),
  },
  {
    title: 'WhatsApp Numbers',
    path: '/number',
    icon: getIcon('eva:phone-fill'),
  },
  {
    title: 'message templates',
    path: '/template',
    icon: getIcon('eva:file-text-fill'),
  },
  {
    title: 'Broadcast',
    path: '/broadcast',
    icon: getIcon('material-symbols:campaign'),
  },
  {
    title: 'Main Credits',
    path: '/credits',
    disabled: true,
    icon: getIcon('ph:credit-card-fill'),
  },
];

const getSidebarConfig = (role, status, email) => {
  const check = !blacklistUser.some((item) => item === email);
  // console.log("RR", check);
  if (status !== 'PENDING') {
    if (
      (role === 'SUPER_ADMIN' || role === 'ADMIN') &&
      check &&
      email === 'admin@admin.com'
    ) {
      return adminSidebarConfig;
    } else if (
      (role === 'SUPER_ADMIN' || role === 'ADMIN') &&
      check &&
      email !== 'admin@admin.com'
    ) {
      return adminSidebarConfigDisabled;
    } else if (role === 'MEMBER' && check) {
      return userSidebarConfig;
    } else if ((role === 'SUPER_ADMIN' || role === 'ADMIN') && !check) {
      return adminSidebarConfigBlackList;
    } else if (role === 'MEMBER' && !check) {
      return userSidebarConfigBlackList;
    }
  } else {
    if ((role === 'SUPER_ADMIN' || role === 'ADMIN') && check) {
      return adminSidebarConfigPending;
    } else if (role === 'MEMBER' && check) {
      return userSidebarConfigPending;
    } else if ((role === 'SUPER_ADMIN' || role === 'ADMIN') && !check) {
      return adminSidebarConfigBlackList;
    } else if (role === 'MEMBER' && !check) {
      return userSidebarConfigBlackList;
    }
  }

  return [];
};

export default getSidebarConfig;
